module.exports = __webpack_public_path__ + "static/img/female-bg-en.8605c15d.png";